import React from 'react';
import SideNav from "../Dashboard/SideNav";
import Navbar from "../Dashboard/Navbar";
import "../Dashboard/styles.css";
import RegisterForm from "../Header/logins/adminregister";

// Define the handleRegister function outside of ParentComponent
const handleRegister = (name) => {
  console.log(`User ${name} registered successfully.`);
  // Do something after successful registration, like redirecting or updating state
};

export default function Useredit() {
  return (
    <>
      <Navbar />
      <SideNav />
      <div className="db-info-wrap">
        <div className="row">
          <div className="col-lg-12">
            <h1>Admin Registration</h1>
            {/* Pass the handleRegister function to RegisterForm */}
            <RegisterForm onRegister={handleRegister} />
          </div>
        </div>
      </div>
      {/* Content / End */}
    </>
  );
}
